export default "__VITE_ASSET__c2b87be4__"